import CustomText from "./CustomText";
import "./Style.scss";

export { CustomText };
